import React from "react";
import {
  Container,
  Paper,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Grid,
} from "@mui/material";
import AudioPlayer from "./AudioPlayer";
import sampleAudio from "../../assets/Demo_1.mp4";

const DemoPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Container
      maxWidth="lg"
      sx={{
        py: { xs: 4, md: 8 },
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} md={10} lg={8}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 3, md: 5 },
              borderRadius: 2,
              background: "white",
              boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0px 12px 30px rgba(0, 0, 0, 0.15)",
              },
            }}
          >
            <Typography
              variant="h3"
              component="h1"
              align="center"
              gutterBottom
              sx={{
                color: "#4472c6",
                fontWeight: 600,
                mb: 4,
                fontSize: { xs: "2rem", md: "2.5rem" },
              }}
            >
              Experience Our AI Interviewer
            </Typography>

            <Typography
              variant="body1"
              align="center"
              sx={{ mb: 5, color: "#555", maxWidth: "80%", mx: "auto" }}
            >
              Listen to a sample interview conducted by our AI interviewer. Hear how natural and human-like our technology sounds, adapting dynamically to candidate responses.
            </Typography>

            <Box sx={{ mb: 4 }}>
              <AudioPlayer
                audioFile={sampleAudio}
                title="AI Interviewer Demo"
              />
            </Box>

            <Box sx={{ mt: 6, textAlign: "center" }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 500, color: "#333", mb: 2 }}
              >
                Key Features Demonstrated
              </Typography>
              <Grid container spacing={3} justifyContent="center">
                {[
                  {
                    title: "Natural Voice Interaction",
                    description: "Human-like conversation flow and voice quality",
                  },
                  {
                    title: "Dynamic Questioning",
                    description: "Questions that adapt based on previous responses",
                  },
                  {
                    title: "Candidate Assessment",
                    description: "Real-time evaluation of communication skills",
                  },
                ].map((feature, index) => (
                  <Grid item xs={12} sm={4} key={index}>
                    <Paper
                      sx={{
                        p: 2,
                        height: "100%",
                        background: "rgba(68, 114, 198, 0.05)",
                        border: "1px solid rgba(68, 114, 198, 0.1)",
                        borderRadius: 1,
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 600, mb: 1, color: "#4472c6" }}
                      >
                        {feature.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {feature.description}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DemoPage;